import type { ComponentType } from 'react'

type ExperiencesCollection = {
  ntExperiencesCollection?: {
    items?: (unknown | null)[] | null
  } | null
}

export function hasExperiences(entry: ExperiencesCollection | null | undefined): boolean {
  const items = entry?.ntExperiencesCollection?.items ?? []
  return items.filter(Boolean).length > 0
}

export function createExperienceAwareEntry<TEntry extends ExperiencesCollection>(
  BaseComponent: ComponentType<{ entry: TEntry }>,
  ExperienceComponent: ComponentType<{ entry: TEntry }>,
) {
  return function ExperienceAwareEntry({ entry }: { entry: TEntry }) {
    if (!hasExperiences(entry)) {
      return <BaseComponent entry={entry} />
    }

    return <ExperienceComponent entry={entry} />
  }
}
